/**
 * Truncates the string by length
 * @param {string} str 
 * @param {number} [length] - Length of the string
 */
export function truncate(str, length) {
  return str.length < length || !length ? str : `${str.substring(0, length)}...`;
}